"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ = require(".");
function formatDuration() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opens_at = duration.opens_at,
    closes_at = duration.closes_at,
    opens = duration.opens,
    closes = duration.closes;
  if (duration.opens_at !== undefined) {
    return "".concat((0, _.formatTimeOfDay)(opens_at), " - ").concat((0, _.formatTimeOfDay)(closes_at));
  }
  return "".concat((0, _.formatTimeOfDay)(opens), " - ").concat((0, _.formatTimeOfDay)(closes));
}
var _default = exports["default"] = formatDuration;